import React from 'react'
import PropTypes from 'prop-types'
import { Dialog } from '@material-ui/core'
import { useModalStyles } from './modals.styles'

const Modal = React.forwardRef((props, ref) => {
  const classes = useModalStyles()
  const { open, onClose, ...other } = props
  return (
    <Dialog open={open} onClose={onClose} ref={ref} {...other}>
      {props.children}
    </Dialog>
  )
})
export default Modal
Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node
}
